
(async () => {
    const { Core } = await importModule('Core');

    const CN_ACTIVE = '!active';
    const CN_SCROLLABLE = '!scrollable';
    const CN_SCROLL_START = '!scroll-start';
    const CN_SCROLL_END = '!scroll-end';
    const SCROLL_EDGE_THRESHOLD = 4;

    customElements.define('tabs-nav' , class extends Core {
        
        elements = {
            navs: '*[data-tab-nav]',
            items: '[data-tab-items]'
        }

        render() {
            this.$activeNav = this.$navs[0];
            this.$navs.map(this._listenClick.bind(this))

            this._checkScrollable();

            if (this.$items) {
                this.$items.addEventListener('scroll', this._checkScrollPosition.bind(this), { passive: true });
            }
            window.addEventListener('resize', this._debouncedCheckScrollable.bind(this));
        }

        _listenClick(nav){
            nav.addEventListener('click', () => this._setActive(nav));
        }

        _setActive(nav) {
            if (nav === this.$activeNav) return;
            if (window.innerWidth <= 992 ) {
                nav.scrollIntoView({ behavior: 'smooth', inline: "center", block: "nearest" });
            }
            this.$activeNav.classList.remove(CN_ACTIVE);
            this.$activeNav = nav;
            this.$activeNav.classList.add(CN_ACTIVE);
        }

        _checkScrollable() {
            if (!this.$items) return;
            const scrollable = this.$items.scrollWidth > this.$items.clientWidth + 1;
            this.classList.toggle(CN_SCROLLABLE, scrollable);
            this._checkScrollPosition();
        }

        _checkScrollPosition() {
            if (!this.$items) return;
            const atStart = this.$items.scrollLeft <= SCROLL_EDGE_THRESHOLD;
            const atEnd = this.$items.scrollLeft + this.$items.clientWidth >= this.$items.scrollWidth - SCROLL_EDGE_THRESHOLD;
            this.classList.toggle(CN_SCROLL_START, atStart);
            this.classList.toggle(CN_SCROLL_END, atEnd);
        }

        _debouncedCheckScrollable() {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(this._checkScrollable.bind(this), 150);
        }
    })
})();
